import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MDBModalRef, MDBModalService } from "angular-bootstrap-md";
import { ModalChoiceComponent } from "../modals/modal-choice/modal-choice.component";
import { ModalFormAnswerListComponent } from "../modals/modal-form-answer-list/modal-form-answer-list.component";
import { ModalFormAnswerComponent } from "../modals/modal-form-answer/modal-form-answer.component";
import { ModalFormCreateComponent } from "../modals/modal-form-create/modal-form-create.component";
import { ModalFormDetailComponent } from "../modals/modal-form-detail/modal-form-detail.component";
import { ModalFormFillComponent } from "../modals/modal-form-fill/modal-form-fill.component";
import { ModalFormPermissionsComponent } from "../modals/modal-form-permissions/modal-form-permissions.component";
import { ModalMessageComponent } from "../modals/modal-message/modal-message.component";
import { CompanyService } from "../service/company.service";
import { MatSort } from "@angular/material/sort";
import { ModalFormModelListComponent } from "../modals/modal-form-model-list/modal-form-model-list.component";
import { ActivatedRoute, Router } from "@angular/router";
import { EmailTemplateService } from "../service/emailtemplate.service";
import { ModalEmailTemplateCreateComponent } from "../modals/modal-email-template-create/modal-email-template-create.component";
import { ModalEmailTemplateSendComponent } from "../modals/modal-email-template-send/modal-email-template-send.component";

@Component({
  selector: "app-emails",
  templateUrl: "./emails.component.html",
  styleUrls: ["./emails.component.css"],
})
export class EmailsComponent implements OnInit {
  constructor(
    private emailTemplateService: EmailTemplateService,
    private modalService: MDBModalService,
    private route: ActivatedRoute,

    private router: Router
  ) {}
  company_type = localStorage.getItem("companyType");
  displayedColumns: string[] = ["empty", "id", "image", "name", "isBirthday", "icons"];
  data_source = new MatTableDataSource<any>();

  modalRef: MDBModalRef;

  is_loaded: boolean = false;

  /* pagination related variabels */
  page: number = 1;
  count_total: number = 0;
  page_count1: number = 0;
  page_count2: number = 0;
  page_size = 10;

  is_company_admin: boolean = false;
  editingForm = false;
  
  core_plan_id: any;
  core_plan_name: any;

  ngOnInit(): void {
    this.getEmail(1);
  }

  truncateString(str, max) {
    return str.length > max ? str.substr(0, max - 1) + "…" : str;
  }

  getEmail(page) {
    this.is_loaded = false;

    this.emailTemplateService.getAll().subscribe(
      (data) => {
        //console.log(data);

        this.data_source.data = data;
        

        // pagination calc
        this.page = page;
        this.count_total = data.length;
        this.page_count1 = 1 + (page - 1) * this.page_size;
        if (this.page_count1 + (this.page_size - 1) > this.count_total) {
          this.page_count2 = this.count_total;
        } else {
          this.page_count2 = this.page_count1 + (this.page_size - 1);
        }
        this.is_loaded = true;
      },
      (error) => {
        //console.log(error);
        this.is_loaded = true;
      }
    );
  }

  newForm() {
    this.modalRef = this.modalService.show(ModalEmailTemplateCreateComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: true,
      class: "modal-dialog-centered modal-dialog modal-lg",
      containerClass: "",
      animated: false,
      data: {
        title: "Adicionar Template de e-mail",
        btn_text: "Adicionar",
        is_new: true,
        
      },
    });
    this.modalRef.content.action.subscribe((result: any) => {
      if (result) {
        this.getEmail(this.page);
        this.modalRef.hide();
      }
    });
  }

  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  /**
   * The `editForm` function opens a modal form for editing permissions and other
   * details, then updates the form data based on the user input.
   * @param form - It looks like the `editForm` function is responsible for opening a
   * modal dialog to edit form permissions and other details. The function takes a
   * `form` object as a parameter, which contains various properties such as
   * `doctors`, `access_to_patient`, `caption_text`, `caption_image`, and
   */

  editForm(form) {
    //console.log(form);
    this.modalRef = this.modalService.show(ModalEmailTemplateCreateComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      width: "100%",
      ignoreBackdropClick: true,
      containerClass: "",
      class: "modal-dialog-centered modal-dialog modal-xl",
      StyleSheet: { width: "100% !important" },
      animated: false,
      data: {
        title: "Editar Template de e-mail",
        btn_text: "Salvar",
        is_new: false,
        text: form.text,
        name: form.name, 
        isBirthday: form.isBirthday,
        id: form.id
      },
    });
    this.modalRef.content.action.subscribe((result: any) => {
      if (result) {
        this.getEmail(1);
      }
    });
  }

  deleteForm(form) {
    // this.openMessage(
    //   `Informação.`,
    //   "Essa funcionalidade está sendo desenvolvida, em breve será liberada para você =)",
    //   false
    // );
    // return;
    this.modalRef = this.modalService.show(ModalChoiceComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: true,
      class: "modal-dialog-centered modal-dialog",
      containerClass: "",
      animated: false,
      data: {
        title: "Confirmação",
        text: `Tem certeza que deseja deletar o formulário ${form.name}?`,
      },
    });
    this.modalRef.content.action.subscribe((result: any) => {
      if (result == "yes") {
        this.openMessage("Por favor, aguarde", "", true);
        this.emailTemplateService.delete(form.id).subscribe(
          (data) => {
            this.modalRef.hide();
            this.openMessage(
              "Deletado!",
              "Template deletado com sucesso.",
              false
            );
            this.getEmail(this.page);
          },
          (error) => {
            this.modalRef.hide();
            this.error(error, "deletar");
          }
        );
      }
    });
  }

  answerForm(form) {
    this.modalRef = this.modalService.show(ModalEmailTemplateSendComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: true,
      class: "modal-dialog-centered modal-dialog modal-xl",
      containerClass: "",
      animated: false,
      data: {
        title: "Enviar e-mails",
        templateId: form.id
      },
    });
  }

  error(error, string) {
    var msg = "";
    if (
      error.error != null &&
      error.error.error != null &&
      error.error.error.length < 50
    )
      msg = error.error.error;
    else msg = "Por favor verifique as informações inseridas";
    this.openMessage(`Erro, não foi possível ${string} o médico.`, msg, false);
  }

  openMessage(title, text, bgclick: boolean) {
    this.modalRef = this.modalService.show(ModalMessageComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: bgclick,
      class: "modal-dialog-centered modal-dialog",
      containerClass: "",
      animated: false,
      data: {
        title: title,
        text: text,
      },
    });
  }

  

  showFormModels() {
    this.modalRef = this.modalService.show(ModalFormModelListComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: true,
      class: "modal-dialog-centered modal-dialog modal-lg",
      containerClass: "",
      animated: false,
      data: {
        title: "Formulários modelo",
        btn_text: "Adicionar",
        is_new: true,
      },
    });
    this.modalRef.content.action.subscribe((result: any) => {
      if (result) {
        this.showCreateWithData(result);
        this.modalRef.hide();
      }
    });
  }

  showCreateWithData(form) {
    console.log(form);

    form.questions.map((question) => {
      const ans = {
        titleQuestion: question.title,
        position: question.position,
        is_selectable: question.is_selectable,
        is_list: question.is_list,
        is_numeric: question.is_numeric,
        is_numeric_scale: question.is_numeric_scale,
        is_image: question.is_image,

        is_date: question.is_date,
        type_date: question.type_date,
        is_frequency: question.is_frequency,
        min_frequency: question.min_frequency,
        max_frequency: question.max_frequency,
        range_frequency: question.range_frequency,
        is_scale: question.is_scale,

        required: question.required,
        number_of_choices: question.number_of_choices,
        alternatives: [],
      };

      ans.alternatives = question.alternatives.map((alternative) => {
        const aux = {
          titleQuestion: alternative.title,
          position: alternative.position,
          score: alternative.score,
        };
        return aux;
      });

      return ans;
    });
    this.modalRef = this.modalService.show(ModalFormCreateComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: true,
      class: "modal-dialog-centered modal-dialog modal-lg",
      containerClass: "",
      animated: false,
      data: {
        title: "Adicionar Formulário",
        btn_text: "Adicionar",
        is_new: true,
        core_plan_id: this.core_plan_id,
        titleQuestion: form.title,
        caption_image: form.caption_image,
        caption_text: form.caption_text,
        questions: form.questions.map((question) => {
          const ans = {
            title: question.title,
            position: question.position,
            is_selectable: question.is_selectable,
            is_list: question.is_list,
            is_numeric: question.is_numeric,
            is_numeric_scale: question.is_numeric_scale,
            is_image: question.is_image,
            is_date: question.is_date,
            type_date: question.type_date,
            is_frequency: question.is_frequency,
            min_frequency: question.min_frequency,
            max_frequency: question.max_frequency,
            range_frequency: question.range_frequency,
            is_scale: question.is_scale,
            required: question.required,
            number_of_choices: question.number_of_choices,
            alternatives: [],
          };

          ans.alternatives = question.alternatives.map((alternative) => {
            const aux = {
              title: alternative.title,
              position: alternative.position,
              score: alternative.score,
            };
            return aux;
          });

          return ans;
        }),
      },
    });
    this.modalRef.content.action.subscribe((result: any) => {
      if (result) {
        this.getEmail(this.page);
        this.modalRef.hide();
      }
    });
  }

  openScalesPage() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(["/home/scales"])
    );
    window.open(url, "_blank");
  }

  openImage(url) {
    window.open(url, "_blank");
  }
}
